import { getUploadsListApi, post, uploadAudioFileToS3 } from '../../utils/api';

async function putAudioFile(url, data, token) {
  try {
    const metadata = data.metadata;
    let response = await post(url, metadata, token);

    if (response && response.status === 200) {
      if (response.data && response.data.url) {
        const fileBlob = data.file;
        const uploadUrl = response.data.url;
        response = await uploadAudioFileToS3(uploadUrl, fileBlob);
      }
    }

    return response;
  } catch (error) {
    return { status: 500, error: 'Failed to upload audio file' };
  }
}

async function getUploadsList(url, token) {
  try {
    const response = await getUploadsListApi(url, token);
    return response;
  } catch (error) {
    return { status: 500, error: 'Failed to fetch audio file' };
  }
}

export { putAudioFile, getUploadsList };
